import React, { Component, useEffect, useState } from 'react';
import HeaderComponent from '../header';
import './index.scss';
import copy from './copy.png';

import useAxiosInterceptors from '../config/axios-config';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

export default class SignatureComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            signatureList: [],
            show: false,
            setSelectedFile: null,
            name: '',
            signatureLocation: '',
            signatureReason: '',
            showDelete: false,
            selectedSignature: null,
            stage: null,
            loading: false
        };
    };

    handleClose = () => {
        this.setState({
            show: false,
            selectedSignature: null
        });
    };

    handleSubmit = (event) => {
        event.preventDefault();
        if (this.state.selectedSignature != null) {
            this.updateSignature();
        } else {
            this.addSignature();
        }
    };

    addSignature = () => {
        var data = {
            signatureReason: this.state.signatureReason,
            signatureLocation: this.state.signatureLocation,
            name: this.state.name,
        }
        try {
            this.setState({
                loading: true
            });
            useAxiosInterceptors.put("/app/signature/v1/new", data, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
                .then((res) => {
                    this.loadData();
                    this.showSuccessToast("Signature created successfully");
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    //Hide loader here
                    this.setState({
                        show: false,
                        stage: null,
                        selectedSignature: null,
                        loading: false
                    });
                })
        } catch (error) {
            console.log(error)
        }
    }

    updateSignature = () => {
        var data = {
            signatureId: this.state.selectedSignature.signatureId,
            signatureReason: this.state.signatureReason,
            signatureLocation: this.state.signatureLocation,
            name: this.state.name,
        }
        try {
            this.setState({
                loading: true
            });
            useAxiosInterceptors.post("/app/signature/v1/update", data, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
                .then((res) => {
                    this.loadData();
                    this.showSuccessToast("Signature updated successfully");
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    //Hide loader here
                    this.setState({
                        show: false,
                        stage: null,
                        selectedSignature: null,
                        loading: false
                    });
                })
        } catch (error) {
            console.log(error)
        }
    }

    nameChange = (event) => {
        this.setState({ name: event.target.value });
    }

    signatureLocationChange = (event) => {
        this.setState({ signatureLocation: event.target.value });
    }
    signatureReasonChange = (event) => {
        this.setState({ signatureReason: event.target.value });
    }

    handleShow = () => {
        this.setState({
            show: true,
            stage: "new"
        });
    };

    handleUpdateShow = (d) => {
        console.log(d)
        this.setState({
            show: true,
            stage: "update",
            selectedSignature: d,
            name: d.name,
            signatureLocation: d.location,
            signatureReason: d.purpose
        });
        this.setState({ stage: "update" })
        console.log(this.state)
    };

    handleDelete = (d) => {
        this.setState({ selectedSignature: d });
        this.setState({ showDelete: true });
    }

    hideDeletePopUp = () => {
        this.setState({ selectedSignature: null });
        this.setState({ showDelete: false });
    }

    handleDeleteConfirm = () => {
        this.setState({
            loading: true
        });
        useAxiosInterceptors.delete(`/app/signature/v1/delete?signatureId=${this.state.selectedSignature.signatureId}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res) => {
                this.loadData();
                this.state.selectedSignature = null;
                this.showSuccessToast("Signature deleted successfully");
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                //Hide loader here
                this.setState({
                    show: false,
                    stage: null,
                    selectedSignature: null,
                    loading: false
                });
            })
        this.setState({ showDelete: false });
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {

        this.setState({
            loading: true
        });
        useAxiosInterceptors.get("/app/signature/v1/all", {
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((res) => {
                this.state.signatureList = res.data;
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                //Hide loader here
                this.setState({
                    show: false,
                    stage: null,
                    selectedSignature: null,
                    loading: false
                });
            });
    }

    render() {
        const { signatureList } = this.state;
        const { selectedSignature } = this.state;
        const { loading } = this.state;

        return (
            <div>
                <HeaderComponent />
                <>
                    {loading ?
                        <>
                            <div className="overlay">
                                <div className="overlay__inner">
                                    <div className="overlay__content">
                                        <span className="spinner"></span>
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        <>
                            {this.state.show}
                            <div className="container mt-5">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <h3 className='mb-3'>Signatures Configured</h3>
                                    </div>
                                    <div className="col-lg-6 text-right">
                                        <button className='btn btn-primary' onClick={this.handleShow}>Configure new signature</button>
                                    </div>
                                    {signatureList.map(d => (
                                        <div className="col-lg-6">
                                            <div className="card p-4">
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <span className=' badge bg-custom cert-name copy-button' onClick={() => { navigator.clipboard.writeText(d.signatureId) }}>
                                                            {d.signatureId} &nbsp;
                                                            <img className='action-icons' src={copy}></img>
                                                        </span>
                                                    </div>
                                                    <div className="col-lg-6 mt-3">
                                                        <h3 className='cert-name'>{d.name}</h3>
                                                    </div>

                                                    <div className="col-lg-12 mt-2 sign-reason">
                                                        <p>{d.purpose}</p>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <p>{d.location}</p>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="btn btn-sm btn-outline-primary" onClick={() => this.handleUpdateShow(d)}>Edit</div>
                                                        <div className="mx-2 btn btn-sm btn-outline-danger" onClick={() => this.handleDelete(d)}>Delete</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                            </div>
                            <Modal
                                size="md"
                                show={this.state.showDelete}
                                aria-labelledby="example-modal-sizes-title-sm"
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title id="example-modal-sizes-title-sm">
                                        Confirm
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <h5>Are you sure you want to delete this signature?
                                        {selectedSignature != null && selectedSignature.signatureId}
                                    </h5>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={this.hideDeletePopUp}>
                                        Cancel
                                    </Button>
                                    <Button variant="danger" onClick={this.handleDeleteConfirm}>
                                        Confirm
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                            <Modal show={this.state.show} onHide={this.handleClose}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Create your signature</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Signature Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                defaultValue={this.state.selectedSignature != null ? this.state.selectedSignature.name : ''}
                                                onChange={this.nameChange}
                                                placeholder="Enter signature name"
                                                autoFocus
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput2">
                                            <Form.Label>Location</Form.Label>
                                            <Form.Control
                                                type="text"
                                                defaultValue={this.state.selectedSignature != null ? this.state.selectedSignature.location : ''}
                                                onChange={this.signatureLocationChange}
                                                placeholder="Enter signature location"
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                            <Form.Label>Reason</Form.Label>
                                            <Form.Control
                                                type="text"
                                                defaultValue={this.state.selectedSignature != null ? this.state.selectedSignature.purpose : ''}
                                                onChange={this.signatureReasonChange}
                                                placeholder="Enter reason"
                                            />
                                        </Form.Group>
                                    </Form>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={this.handleClose}>
                                        Close
                                    </Button>
                                    <Button variant="primary" onClick={this.handleSubmit}>
                                        Save Changes
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        </>
                    }
                </>

            </div>
        );
    };

}

// export default UploadComponent;
